"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Purchase prices are maintained within external system. They are entered in the original currency in which purchases are realized.
 * Price is displayed in default system currency, if original currency differs from the system default, it is recalculated with the
 * exchange rate that is set withing external system.
 *
 * @author RV
 */


var PurchasePriceRow =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(PurchasePriceRow, _StateDomainObject_1$);

  /**
   * Constructs purchase price row instance.
   *
   * @param id
   * @param externalId
   * @param productId
   * @param groupOfSiteId
   * @param amount price excluding VAT before discounts (eg. distribution bonus). Be aware that amount is in the currency of supplier.
   * @param amountNett price excluding VAT after discounts. Be aware that amount is in the currency of supplier.
   * @param vatId the internal id of VAT
   * @param supplierId
   * @param validFrom
   * @param validTo null means infinity
   * @param promotionId the internal id of promotion or null
   * @param stateFlags
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function PurchasePriceRow(id, externalId, productId, groupOfSiteId, amount, amountNett, vatId, supplierId, validFrom, validTo, promotionId, stateFlags, processed) {
    var _this;

    _classCallCheck(this, PurchasePriceRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PurchasePriceRow).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.productId = productId;
    _this.groupOfSiteId = groupOfSiteId;
    _this.amount = amount;
    _this.amountNett = amountNett;
    _this.vatId = vatId;
    _this.supplierId = supplierId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.promotionId = promotionId;
    _this.stateFlags = stateFlags;
    _this.processed = processed;
    return _this;
  }

  return PurchasePriceRow;
}(StateDomainObject_1.StateDomainObject);

exports.PurchasePriceRow = PurchasePriceRow;

PurchasePriceRow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PurchasePriceRow.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    productId: builder.str('productId'),
    groupOfSiteId: builder.str('groupOfSiteId'),
    amount: builder.bigNum('amount'),
    amountNett: builder.bigNum('amountNett'),
    vatId: builder.str('vatId'),
    supplierId: builder.str('supplierId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.opt(builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)),
    promotionId: builder.opt(builder.str('promotionId')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    processed: builder.bool('processed')
  };
}();